import React, { useEffect } from 'react';
import NProgress from 'react-nprogress';

import { ReactKeycloakProvider } from '@react-keycloak/web';
import { ConfigProvider } from 'antd';
import antdPtBr from 'antd/es/locale/pt_BR';
import { ThemeProvider } from 'styled-components';

import 'react-nprogress/nprogress.css';
import 'animate.css/animate.min.css';
import '~/assets/styles/antd/antd.less';

import CustomStyle from '~/assets/styles/custom';
import GlobalStyle from '~/assets/styles/global';
import theme from '~/assets/styles/theme';
import Routes from '~/constants/routes';
import { setSessaoToken } from '~/helpers/token';
import keycloack, { keycloakInitConfiguration } from '~/keycloak';

function App() {
  NProgress.configure({ parent: '.ant-layout-content' });

  const { pathname } = window.location;

  // TODO: Pensar em possível ajuste - alterações do keycloak
  useEffect(() => {
    if (
      pathname !== '/' &&
      pathname !== '/novo' &&
      pathname !== '/novo/tipo-template' &&
      pathname !== '/home'
    ) {
      window.history.replaceState(null, null, '/home');
    }
  }, []);

  return (
    <ReactKeycloakProvider
      authClient={keycloack}
      initOptions={keycloakInitConfiguration}
      onTokens={({ token }) => {
        setSessaoToken({
          access_token: token,
        });
      }}
    >
      <ConfigProvider locale={antdPtBr}>
        <ThemeProvider theme={theme}>
          <GlobalStyle />
          <CustomStyle />

          <Routes />
        </ThemeProvider>
      </ConfigProvider>
    </ReactKeycloakProvider>
  );
}

export default App;
